var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Vlt-callout",class:_vm.classArray,attrs:{"id":_vm.id}},[_c('i'),_c('div',{staticClass:"Vlt-callout__content"},[_vm._t("default")],2),(_vm.dismissable)?_c('button',{staticClass:"Vlt-callout__dismiss",on:{"click":_vm.dismiss}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }